@if(createKeyError$){
<ng-container *ngTemplateOutlet="viewCreatedKeyError"></ng-container>
} @else {
<ng-container *ngTemplateOutlet="viewCreatedKey"></ng-container>
}

<!-- View Created Key -->
<ng-template #viewCreatedKey>
  <div class="rh-create-key-section" *ngIf="createdKey$">
    <mat-grid-list cols="1" rowHeight="650">
      <mat-grid-tile>
        <mat-card [style.width]="'60%'" [style.height]="'600px'">
          <mat-card-header>
            <mat-card-title>Create Key Response:</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="rh-create-key-wrapper">
              <br />
              @for(key of createdKeyObject; track $index ) {
              @if (key === 'key') {
              <p><strong class="mat-title-large">{{key | uppercase}}: {{ createdKey$[key] }}</strong></p>
              <p><i>Note: this is the only time the key value will be available. Please store this value securely.</i>
              </p>
              <br />
              } @else {
              <p class="mat-body-large"><strong [style.fontWeight]="'var(--mat-expansion-header-text-weight)'">{{key |
                  uppercase}}:</strong> {{ createdKey$[key] | json }}
              </p>
              }
              }
              <br />
            </div>
          </mat-card-content>
          <mat-card-footer class="rh-card-footer">
            <mat-chip-set aria-label="Reset Action">
              <mat-chip (click)="reset()" (keydown)="reset()">Reset</mat-chip>
            </mat-chip-set>
          </mat-card-footer>
        </mat-card>
      </mat-grid-tile>
    </mat-grid-list>
  </div>
</ng-template>

<!-- View Error -->
<ng-template #viewCreatedKeyError>
  <mat-grid-list cols="1" rowHeight="100px">
    <mat-grid-tile rowspan="3">
      <mat-form-field>
        <mat-label>Create Key Error Response</mat-label>
        <textarea matInput readonly cols="100" rows="10" [style.resize]="'none'">{{
          createKeyError$
        }}</textarea>
      </mat-form-field>
    </mat-grid-tile>
  </mat-grid-list>
</ng-template>